export class ShippingOfferTypes {
    public static Free : number = 3;
    public static Fixed : number = 1;
    public static Dynamic : number = 2;
}